import { Action } from 'redux';

import { NewWorkbookForPublishedConnection } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface NewWorkbookForPublishedConnectionAction extends Action {
  contentInfo: IContentInfo;
}

export function newWorkbookForPublishedConnection(contentInfo: IContentInfo): NewWorkbookForPublishedConnectionAction {
  return {
    type: NewWorkbookForPublishedConnection,
    contentInfo
  };
}

export const isNewWorkbookForPublishedConnectionAction = isActionFactory<NewWorkbookForPublishedConnectionAction>(NewWorkbookForPublishedConnection);
